<div class="btn-group"
     dropdown
     appStopClickPropagation
     placement="bottom right"
     #dropdown="bs-dropdown">
    <button id="user-picture"
            dropdownToggle
            type="button"
            class="badge-secondary"
            aria-controls="dropdown-user-profile">
        <ui-user-profile-picture class="button-user-picture"
                                 [userInitials]="userInitials"
                                 [userPhoto]="userPhoto">
        </ui-user-profile-picture>
        <span class="icon-arrow-expand" [ngClass]="{'is-open': dropdown.isOpen}"></span>
    </button>
    <ul id="dropdown-user-profile" appStopClickPropagation *dropdownMenu class="dropdown-menu dropdown-menu-right"
        role="menu" aria-labelledby="user-picture">
        <li role="menuitem">
            <div class="dropdown-top">
                <ui-user-profile-picture class="badge-secondary dropdown-user-picture"
                                         [userInitials]="userInitials"
                                         [userPhoto]="userPhoto">
                </ui-user-profile-picture>
                <div class="text-wrapper">
                    <div class="user-name">{{ user.fullName }}</div>
                    <!-- TODO remove next line after the roles will be implemented-->
                    <div class="light-text">{{user.userRoleName}}</div>
                </div>
            </div>
        </li>

        <li *ngIf="isProfileAvaliable" role="menuitem" >
            <a id="user-profile"
               appTrackClickButton
               dropdownToggle
               class="dropdown-item"
               [routerLink]="['/profile', user.userId]">
                <i class="icon-user-1"></i>
                My profile
            </a>
            <hr class="dropdown-menu-divider">
        </li>

        <ui-link-items [dropdown]="dropdown"></ui-link-items>
    </ul>
</div>
